
import CollapseTransition from "~/components/shared/CollapseTransition.vue";
import { replacePlaceholder } from "~/utils";

export default {
  name: "SizeGuide",
  components: { CollapseTransition },
  props: {
    data: {
      type: Object,
      required: true,
    },
    accordion: {
      type: Boolean,
      default: false,
    },
    sizeGuideUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activeItems: [],
    };
  },
  computed: {
    isBlockActive() {
      return (idx) => {
        const block = this.data.list[idx];
        if (!block.title) {
          return true;
        }
        return this.activeItems.includes(idx);
      };
    },
  },
  methods: {
    toggleActive(idx) {
      const block = this.data.list[idx];

      if (!block.title) {
        return;
      }

      if (this.accordion) {
        this.activeItems = this.activeItems.includes(idx) ? [] : [idx];
        return;
      }

      if (this.activeItems.includes(idx)) {
        this.activeItems = this.activeItems.filter((item) => item !== idx);
      } else {
        this.activeItems.push(idx);
      }
    },
    processPlaceholders(text) {
      if (!text) return text;

      return replacePlaceholder(text, (variable) => {
        switch (variable) {
          case "size_guide_url":
            return this.sizeGuideUrl;
          default:
            return null;
        }
      });
    },
  },
};
